import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

function NotFound() {
  return (
    <section className="basic-page not-found-page">
      <Helmet>
        <title>Page Not Found</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <p className="not-found-pill">Route not found</p>
      <h1 className="not-found-code">404</h1>
      <h2>Looks like this page lost its breathing rhythm.</h2>
      <p>
        The link may have expired, moved, or never existed. Take a steady inhale and head back to the home page.
      </p>
      <Link to="/" className="button button-primary">
        Back Home
      </Link>
    </section>
  );
}

export default NotFound;
